import { AgGridReact } from 'ag-grid-react';
import { action, autorun, computed, observable } from 'mobx';
import { AlertHandle, autostore, bind, Clock, IError, NotificationHandle } from 'Mri.Web.Common';
import { ActiveDisplay } from '../Displays/ActiveDisplay';
import { LiveChartGridOptions } from '../Displays/DisplayView/LiveCharts/LiveChartsGridSelector';

export class AppStore {
    public constructor() {
        if (typeof window != 'undefined') {
            this.innerWidth = window.innerWidth;
            window.addEventListener(
                'resize',
                action(() => (this.innerWidth = window.innerWidth))
            );
        }

        autostore(this.storage, 'AppStore.AppStorage');
        autorun(this.setTheme);
    }

    @bind
    @action
    public setError(error: IError | Error) {
        if (error instanceof Error) {
            this.error = {
                message: error.message,
                file: error.name,
                stack: error.stack,
            };
        } else {
            this.error = error;
        }
    }

    @bind
    @action
    public hideHeader() {
        this.hiddenHeader = true;
    }

    @bind
    @action
    public showHeader() {
        this.hiddenHeader = false;
    }

    @bind
    private setTheme() {
        const el = document.getElementById('main-body');

        if (el && this.storage.theme) {
            el.classList.remove('theme-1');
            el.classList.remove('theme-2');
            el.classList.remove('dark-theme');

            el.classList.add(this.storage.theme);
        }
    }

    @computed
    public get isMobile() {
        return this.innerWidth < 767;
    }

    @computed
    public get isMedium() {
        return this.innerWidth < 992;
    }

    @computed
    public get isLarge() {
        return this.innerWidth < 1200;
    }

    @computed
    public get isModalOpen(): boolean {
        let element = document.getElementsByClassName("modal-open");
        return element.length > 0;

    }

    @observable
    public isIdle: boolean = false;
    @observable
    public storage = new AppStorage();
    @observable
    public alertHandle = new AlertHandle();
    @observable
    public notificationHandle = new NotificationHandle();
    @observable
    public mainContainer: HTMLDivElement | null = null;
    @observable
    public clock = new Clock();
    @observable
    public error?: IError;
    @observable
    public hiddenHeader = false;
    @observable
    public innerWidth = 0;
    //GRID SETTINGS
    @observable
    public gridKey = 0;
    @observable
    public gridInitialized: boolean = true;
    @observable
    public gridRef: AgGridReact<ActiveDisplay> | null = null;
    @observable
    public gridAutoHeaderHeight: boolean = true;
    @observable
    public gridHeaderHeight: number = 40;
}

class AppStorage {
    // UPDATE THIS TO FORCE UPDATES ACROSS TABS
    public static version = '07-11-25.2';

    public isValid() {
        return this.version == AppStorage.version;
    }

    @observable
    public version = AppStorage.version;
    @observable
    public theme: 'theme-1' | 'theme-2' | 'dark-theme' = 'theme-1';
    @observable
    public sidebarCollapsed = true;
    @observable
    public sortedColumn: string = '';
    @observable
    public displayLogTimes: { start: Date | undefined; end: Date | undefined } | undefined = {
        start: undefined,
        end: undefined,
    };
    @observable
    public liveChartSettings = new LiveChartSettings();
    @observable
    public lastMainContainerScrollPositionX: number = 0;
    @observable
    public lastMainContainerScrollPositionY: number = 0;
    @observable
    public gridScrollColumnId: string = '';
    @observable
    public showBulkActionsMenu: boolean = false;
}

class LiveChartSettings {
    @observable
    public liveChartTimeWindow: 1 | 2 | 4 | 8 | 12 | 24 = 2;
    @observable
    public liveChartSelectedChartName: string = '';
    @observable
    public liveChartSelectedGrid: LiveChartGridOptions = LiveChartGridOptions.FourByFour;
    @observable
    public liveChartHideLegend: boolean = true;
    @observable
    public liveChartHide: boolean = false;
    @observable
    public secsPerSample: number = 10;
    @observable
    public triggerSecsPerSampleUpdate: boolean = true;
}
